<template>
    <div>
        <img class="d-block mx-auto" src="@/assets/images/icons/green-tick.svg" width="80" alt="tick">
        <p class="text-center lead font-weight-bold mt-3">Device found</p>
        <div class="text-sm mt-4">
            <div class="row">
                <div class="col-4">Device serial number</div>
                <div class="col-8">{{ data.deviceSerialNumber }}</div>
            </div>

            <hr />

            <div class="row">
                <div class="col-4">Assign to</div>
                <div class="col-8">Order {{ data.orderNumber }}</div>
            </div>

            <div class="d-flex align-items-center mt-45">
                <button :disabled="loading" @click="$emit('close')" class="btn btn-cancel btn-lg lg-shadow d-flex flex-grow-1 w-45 justify-content-center align-items-center" :class="{disabled : loading}">Cancel</button>
                <button :disabled="loading" @click="confirm()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 w-55 ml-3 justify-content-center align-items-center" :class="{disabled : loading}">Assign <span v-if="loading" class="btn-loading"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReassignDeviceModalComponent',

    props: {
        data: Object
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        confirm() {
            //
        }
    }
}
</script>